export default __webpack_public_path__ + "static/media/github.2d2235e5.svg";